import { Card, LinearProgress } from "@material-ui/core";
import axios from "axios";
import Moments from "moment";
import React, { Component } from "react";
import {
  Badge,
  Button,
  ButtonToolbar,
  Form,
  Modal,
  OverlayTrigger,
  Table,
  Tooltip,
  Alert,
} from "react-bootstrap";
import Moment from "react-moment";
import { Link } from "react-router-dom";
import swal from "sweetalert";
import { NoticePeningkatan, YearSelect } from "../../../../../_metronic/_partials/controls";
import AppConfig from "../../../../config/AppConfig";
import {
  Input,
  MenuItem,
  Select,
  ListItemText,
  Checkbox,
} from "@material-ui/core";

const ITEM_HEIGHT = 52;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

class PeningkatanPengelolaanStandar extends Component {
  constructor(props, context) {
    super(props, context);
    this.handleAdd = this.handleAdd.bind(this);
    this.handleShowFormInput = this.handleShowFormInput.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleEdit = this.handleEdit.bind(this);
    this.handleShowHistorical = this.handhandleShowHistorical.bind(this);
    this.handleChangeMultiple = this.handleChangeMultiple.bind(this);
    this.state = {
      data_penetapan: [],
      data_peningkatan: [],
      detail_data: [],
      data_historical: [],
      loadingHistorical: false,
      showDialogFormSave: false,
      showHistorical: false,
      display: false,
      display_edit: false,
      loading: false,
      // form
      id_ajuan_peningkatan: [],
      id_sp: [],
      id_jenis_aturan: [],
      tanggal_penetapan: "",
      status: [],
      tautan: "",
      deskripsi: "",
      peningkatan: [],
      jenis_peningkatan: [],
      data_jenis_peningkatan: [],
      //tautan penetapan
      tautanp: undefined,
    };
  }

  handleAdd() {
    this.setState({
      showDialogFormSave: true,
    });
  }

  handleEdit(jenis, id) {
    let userdata = JSON.parse(localStorage.getItem("userdata"));
    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    let session = "";
    if (userdata) {
      session =
        // "?token="+userdata.token+
        "?id_pengguna=" +
        userdata.id_pengguna +
        "&id_unit=" +
        sessiondata.i_idunit +
        "&id_role=" +
        sessiondata.i_idrole;
    }
    axios
      .get(AppConfig.GetDetailPeningkatan + id + session)
      .then((res) => {
        this.setState({
          detail_data: res.data.result.data,
          display_edit: true,
          id_ajuan_peningkatan: res.data.result.data.id_ajuan_peningkatan,
          showDialogFormSave: true,
          id_sp: sessiondata.i_idunit,
          tautan: res.data.result.data.tautan,
          deskripsi: res.data.result.data.keterangan,
          jenis_peningkatan: JSON.parse(res.data.result.data.jenis_peningkatan) ?? [],
          tanggal_penetapan: Moments(
            res.data.result.data.tanggal_penetapan
          ).format("YYYY-MM-DD"),
          id_jenis_aturan: jenis,
        });
      })
      .catch((err) => {
        this.setState({
          display_edit: false,
          showDialogFormSave: false,
        });
      });
  }
  handhandleShowHistorical = (jenis) => {
    this.setState({ showHistorical: true });
    let userdata = JSON.parse(localStorage.getItem("userdata"));
    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    let session = "";
    if (userdata) {
      session =
        // "?token="+userdata.token+
        "?id_pengguna=" +
        userdata.id_pengguna +
        "&id_unit=" +
        sessiondata.i_idunit +
        "&id_role=" +
        sessiondata.i_idrole;
    }

    let id_institusi = localStorage.getItem("id_sp_temp");
    if (id_institusi === undefined || id_institusi === null) {
      id_institusi = sessiondata.i_idunit;
    }
    let tahun_siklus = localStorage.getItem("tahun_siklus");
    axios
      .get(AppConfig.GetPeningkatanSiklusHistory + id_institusi + "/" + jenis + "/" + tahun_siklus + session)
      .then((res) => {
        this.setState({
          data_historical: res.data.result.data,
          loadingHistorical: true,
        });
      })
      .catch((err) => {
        this.setState({
          display_edit: false,
          showDialogFormSave: false,
        });
      });
  };
  handleShowFormInput(no) {
    let session = JSON.parse(localStorage.getItem("sessiondata"));
    let id_pt = session.i_idunit;
    this.setState({
      showDialogFormSave: true,
      id_sp: id_pt,
      id_jenis_aturan: no,
    });
  }
  onInputChangePengaturan = (e, type) => {
    this.setState({
      [type]: e.target.value,
    });
  };
  handleClose() {
    this.setState({
      showDialogFormSave: false,
      id_ajuan_peningkatan: [],
      id_sp: [],
      id_jenis_aturan: [],
      tanggal_penetapan: [],
      tautan: [],
      deskripsi: [],
      loading: false,
      showHistorical: false,
      jenis_peningkatan: [],
      data_historical: [],
      loadingHistorical: false,
    });
  }
  handleSavePeningkatan = (e) => {
    swal({
      title: "Anda yakin?",
      text: "Pastikan verifikator dapat melihat dokumen yang Anda upload!",
      icon: "warning",
      buttons: true,
      dangerMode: false,
    }).then((willSave) => {
      if (willSave) {
        if (this.state.jenis_peningkatan.length > 0) {
          e.preventDefault();
          var formData = new FormData();
          this.setState({ loading: true });
          let userdata = JSON.parse(localStorage.getItem("userdata"));
          let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
          let session = "";
          if (userdata) {
            session =
              // "?token="+userdata.token+
              "?id_pengguna=" +
              userdata.id_pengguna +
              "&id_unit=" +
              sessiondata.i_idunit +
              "&id_role=" +
              sessiondata.i_idrole;
          }
          formData.append(
            "data[id_ajuan_peningkatan]",
            this.state.id_ajuan_peningkatan
          );
          formData.append("data[id_sp]", sessiondata.i_idunit);
          formData.append("data[id_jenis_aturan]", this.state.id_jenis_aturan);
          formData.append("data[tautan]", this.state.tautan);
          let session_tahun_siklus = localStorage.getItem("tahun_siklus")
          formData.append("data[tahun_siklus]", session_tahun_siklus);
          formData.append("data[keterangan]", this.state.deskripsi);
          // formData.append("data[catatan]", this.state.deskripsi);
          formData.append(
            "data[tanggal_penetapan]",
            this.state.tanggal_penetapan
          );
          formData.append(
            "data[jenis_peningkatan]",
            JSON.stringify(this.state.jenis_peningkatan)
          );
          // let jenis_peningkatan = [];
          // for (let i = 0; i < this.state.jenis_peningkatan.length; i++) {
          //   const val = this.state.jenis_peningkatan[i];
          //   let output = this.state.data_jenis_peningkatan.filter(
          //     (data) => data.nama_jenis === val
          //   );

          //   jenis_peningkatan.push(output[0].id_jenis_aturan);
          // }

          axios
            .post(AppConfig.SavePeningkatan + session, formData)
            .then((res) => {
              this.setState({
                loading: false,
              });
              swal({
                title: "Berhasil!",
                text: "pengaturan berhasil!",
                icon: "success",
                button: "OK!",
              });
              console.log(res);
              this.componentDidMount();
              this.handleClose();
            })
            .catch((err) => {
              swal({
                title: "Gagal!",
                text: "Pengaturan tidak berhasil disimpan!",
                icon: "error",
                button: "OK!",
              });
              console.log(err);
            });
        } else {
          swal({
            title: "Gagal!",
            text:
              "Pengatuan tidak berhasil disimpan! Silahkan pilih nama standar terlebih dahulu.",
            icon: "error",
            button: "OK!",
          });
        }
      }
    });
  };
  handleDelete = (id) => {
    let userdata = JSON.parse(localStorage.getItem("userdata"));
    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    let session = "";
    if (userdata) {
      session =
        // "?token="+userdata.token+
        "?id_pengguna=" +
        userdata.id_pengguna +
        "&id_unit=" +
        sessiondata.i_idunit +
        "&id_role=" +
        sessiondata.i_idrole;
    }
    swal({
      title: "Apakah anda yakin?",
      text: "Catatan pada pengaturan peningkatan akan dihapus",
      icon: "warning",
      buttons: true,
      dangerMode: false,
    }).then((willDelete) => {
      if (willDelete) {
        this.setState({ loading: true });
        axios
          .get(AppConfig.DeletePeningkatan + id + session)
          .then((res) => {
            swal({
              title: "Berhasil!",
              text: "Pengaturan berhasil dihapus!",
              icon: "success",
              button: "OK!",
            });
            this.componentDidMount();
          })
          .catch((err) => {
            swal({
              title: "Gagal!",
              text: "Pengaturan gagal dihapus!",
              icon: "error",
              button: "OK!",
            });
          });
      }
    });
  };
  componentDidMount() {
    this.setState({ display: false });
    let id_institusi = localStorage.getItem("id_sp_temp");
    let userdata = JSON.parse(localStorage.getItem("userdata"));
    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    let session_tahun_siklus = localStorage.getItem("tahun_siklus");
    let id_sp = sessiondata.i_idunit;
    if (id_institusi !== "") {
      id_sp = id_institusi;
    }
    if (id_institusi === null) {
      id_sp = sessiondata.i_idunit;
    }
    let session = "";
    if (this.props.idSp !== undefined) {
      id_sp = this.props.idSp;
    }
    if (id_sp) {
      session =
        // "?token="+userdata.token+
        "?id_pengguna=" +
        userdata.id_pengguna +
        "&id_unit=" +
        id_sp +
        "&id_role=" +
        sessiondata.i_idrole;
    }

    axios
      .get(AppConfig.GetPeningkatanSiklus + id_sp + "/" + session_tahun_siklus + session)
      .then((res) => {
        this.setState({
          peningkatan: res.data.result.data_peningkatan,
          data_peningkatan: res.data.result.peningkatan,
          data_jenis_peningkatan: res.data.result.jenis_peningkatan,
          display: true,
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          LoadDataSukses: false,
        });
      });
  }

  handleChangeMultiple = (e) => {
    this.setState({
      jenis_peningkatan: e.target.value,
    });
  };
  render() {
    let {
      display,
      showDialogFormSave,
      loading,
      data_historical,
      tautan,
      deskripsi,
      tanggal_penetapan,
      peningkatan,
      jenis_peningkatan,
      data_jenis_peningkatan,
    } = this.state;
    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    let role = sessiondata.i_idrole;
    let userdata = JSON.parse(localStorage.getItem("userdata"));

    let view_historical = [];
    if (this.state.loadingHistorical === true) {
      if (data_historical !== undefined) {
        data_historical.map((list, i) => {
          let nama_jenis = [];
          if (list.jenis_peningkatan !== "null") {
            if (JSON.parse(list.jenis_peningkatan).length > 0) {
              let c_nama_jenis = [];
              for (
                let i2 = 0;
                i2 < JSON.parse(list.jenis_peningkatan).length;
                i2++
              ) {
                const val2 = JSON.parse(list.jenis_peningkatan)[i2];
                c_nama_jenis.push(<li>{val2}</li>);
              }
              nama_jenis.push(<ul>{c_nama_jenis}</ul>);
            }
          } else {
            nama_jenis = list.nama_jenis;
          }

          view_historical.push(
            <>
              <tr>
                <td style={{ textAlign: "left" }}>{nama_jenis}</td>
                <td style={{ textAlign: "center" }}>
                  <Button
                    href={list.tautan}
                    target="_blank"
                    className="btn btn-icon btn-light btn-sm"
                    style={{
                      minWidth: "50px",
                      borderRadius: "12px",
                      background: "#A9C6DE",
                    }}
                  >
                    <i
                      className="flaticon-attachment"
                      style={{ color: "#3F4254", fontSize: "14px" }}
                    ></i>
                  </Button>
                </td>
                <td style={{ textAlign: "center" }}>
                  {list.tanggal_penetapan !== "null" ? (
                    <Moment date={list.tanggal_penetapan} format="DD/MM/YYYY" />
                  ) : (
                    "-"
                  )}
                </td>
                <td style={{ textAlign: "center" }}>
                  {list.statusajuan === 3 ? (
                    <Badge
                      pill
                      variant="success"
                      style={{
                        backgroundColor: "#BEF2FF",
                        color: "#334443",
                        fontSize: "12px",
                      }}
                    >
                      <Badge variant="light">
                        {" "}
                        <span style={{ color: "#37bf30" }}>✔</span>
                      </Badge>
                      &nbsp;&nbsp;&nbsp; Terverifikasi
                    </Badge>
                  ) : list.statusajuan === 1 ? (
                    <Badge
                      pill
                      variant="secondary"
                      style={{
                        backgroundColor: "#BEF2FF",
                        color: "#334443",
                        fontSize: "12px",
                      }}
                    >
                      <Badge variant="light">
                        {" "}
                        <span style={{ color: "#858585" }}>•</span>
                      </Badge>
                      &nbsp;&nbsp;&nbsp; Belum Terverifikasi
                    </Badge>
                  ) : (
                    <Badge
                      pill
                      variant="secondary"
                      style={{
                        backgroundColor: "#BEF2FF",
                        color: "#334443",
                        fontSize: "12px",
                      }}
                    >
                      -
                    </Badge>
                  )}
                </td>
                <td style={{ textAlign: "center" }}>
                  {list.statusdokumen === 1 ? (
                    <Badge
                      pill
                      variant="success"
                      style={{
                        backgroundColor: "#BEF2FF",
                        color: "#334443",
                        fontSize: "12px",
                      }}
                    >
                      <Badge variant="light">
                        {" "}
                        <span style={{ color: "#37bf30" }}>✔</span>
                      </Badge>
                      &nbsp;&nbsp;&nbsp; Sudah Valid
                    </Badge>
                  ) : list.statusdokumen === 0 ? (
                    <Badge
                      pill
                      variant="warning"
                      style={{
                        color: "#334443",
                        fontSize: "12px",
                      }}
                    >
                      Belum Valid
                    </Badge>
                  ) : (
                    <Badge
                      pill
                      variant="secondary"
                      style={{ backgroundColor: "#CCCCCC", color: "#FFFFFF" }}
                    >
                      Dokumen belum diverifikasi
                    </Badge>
                  )}
                </td>
              </tr>
            </>
          );
        });
      }
    } else {
      view_historical = (
        <tr>
          <td colSpan="5">
            <LinearProgress color="secondary" variant="query" />
          </td>
        </tr>
      );
    }
    let view = [];
    if (display === true) {

      let penganturan_peningkatan = [];
      for (let i = 0; i < peningkatan.length; i++) {
        const val = peningkatan[i];
        let nama_jenis = [];
        if (JSON.parse(val.jenis_peningkatan).length > 0) {
          let c_nama_jenis = [];
          for (
            let i2 = 0;
            i2 < JSON.parse(val.jenis_peningkatan).length;
            i2++
          ) {
            const val2 = JSON.parse(val.jenis_peningkatan)[i2];
            c_nama_jenis.push(<li>{val2}</li>);
          }
          nama_jenis.push(<ul>{c_nama_jenis}</ul>);
        }

        penganturan_peningkatan.push(
          <>
            <tr>
              <td style={{ fontSize: "12px", verticalAlign: "middle" }}>
                {nama_jenis}
              </td>
              <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                <Button
                  href={val.tautan}
                  target="_blank"
                  className="btn btn-icon btn-light btn-sm"
                  style={{
                    minWidth: "50px",
                    borderRadius: "12px",
                    background: "#A9C6DE",
                  }}
                >
                  <i
                    class="flaticon-attachment"
                    style={{ color: "#3F4254", fontSize: "14px" }}
                  ></i>
                </Button>
              </td>
              <td
                style={{
                  textAlign: "center",
                  fontSize: "12px",
                  verticalAlign: "middle",
                }}
              >
                {val.tanggal_penetapan !== "null" ? (
                  <Moment date={val.tanggal_penetapan} format="DD/MM/YYYY" />
                ) : (
                  "-"
                )}
              </td>
              <td
                style={{
                  textAlign: "center",
                  fontSize: "12px",
                  verticalAlign: "middle",
                }}
              >
                {val.statusajuan === 3 ? (
                  <Badge
                    pill
                    variant="success"
                    style={{
                      backgroundColor: "#BEF2FF",
                      color: "#334443",
                      fontSize: "12px",
                    }}
                  >
                    <Badge variant="light">
                      {" "}
                      <span style={{ color: "#37bf30" }}>✔</span>
                    </Badge>
                    &nbsp;&nbsp;&nbsp; Terverifikasi
                  </Badge>
                ) : (
                  <Badge
                    pill
                    variant="secondary"
                    style={{
                      backgroundColor: "#BEF2FF",
                      color: "#334443",
                      fontSize: "12px",
                    }}
                  >
                    Belum Terverifikasi
                  </Badge>
                )}
              </td>
              <td
                style={{
                  textAlign: "center",
                  fontSize: "12px",
                  verticalAlign: "middle",
                }}
              >
                {val.statusdokumen === 1 ? (
                  <Badge
                    pill
                    variant="success"
                    style={{
                      backgroundColor: "#BEF2FF",
                      color: "#334443",
                      fontSize: "12px",
                    }}
                  >
                    <Badge variant="light">
                      {" "}
                      <span style={{ color: "#37bf30" }}>✔</span>
                    </Badge>
                    &nbsp;&nbsp;&nbsp; Sudah Valid
                  </Badge>
                ) : val.statusdokumen === 0 ? (
                  <Badge
                    pill
                    variant="warning"
                    style={{
                      color: "#334443",
                      fontSize: "12px",
                    }}
                  >
                    Belum Valid
                  </Badge>
                ) : (
                  <Badge
                    pill
                    variant="secondary"
                    style={{ backgroundColor: "#CCCCCC", color: "#FFFFFF" }}
                  >
                    Dokumen belum diverifikasi
                  </Badge>
                )}
              </td>
              <td style={{ textAlign: "center", verticalAlign: "middle" }}>

                &nbsp;
                {role === 10 || role === 2013 || role === 2014 ? (
                  <Link
                    to={"/ajuan-peningkatan/detail/" + val.id_ajuan_peningkatan}
                  >
                    <Button
                      className="btn btn-icon btn-primary btn-sm"
                      style={{ minWidth: "50px", borderRadius: "12px" }}
                    >
                      <i
                        class="flaticon-eye"
                        style={{ color: "#ffffff", fontSize: "14px" }}
                      ></i>
                    </Button>
                  </Link>
                ) : role === 3 ? (
                  <>
                    <Link
                      to={
                        "/ajuan-peningkatan/detail/" + val.id_ajuan_peningkatan
                      }
                    >
                      <Button
                        className="btn btn-icon btn-primary btn-sm"
                        style={{ minWidth: "50px", borderRadius: "12px" }}
                      >
                        <i
                          class="flaticon-eye"
                          style={{ color: "#ffffff", fontSize: "14px" }}
                        ></i>
                      </Button>
                    </Link>
                    &nbsp;
                    {
                      val.statusajuan === 1 || (val.statusdokumen === "null" || val.statusdokumen === 0)? (<Button
                      onClick={() =>
                        this.handleEdit(
                          val.id_jenis_aturan,
                          val.id_ajuan_peningkatan
                        )
                      }
                      className="btn btn-icon btn-warning btn-sm"
                      style={{ minWidth: "50px", borderRadius: "12px" }}
                    >
                      <i
                        class="flaticon-edit"
                        style={{ color: "#ffffff", fontSize: "14px" }}
                      ></i>
                    </Button>) : ("")
                    }
                    &nbsp;
                    {
                      val.statusajuan === 1 && (val.statusdokumen === "null" || val.statusdokumen === 0) ? (
                        <Button
                          onClick={() =>
                            this.handleDelete(val.id_ajuan_peningkatan)
                          }
                          className="btn btn-icon btn-danger btn-sm"
                          style={{ minWidth: "50px", borderRadius: "12px" }}
                    >
                      <i
                        class="flaticon2-trash"
                        style={{ color: "#ffffff", fontSize: "14px" }}
                      ></i>
                    </Button>) : ("")}
                  </>
                ) : (
                  ""
                )}
                &nbsp;
                <Button
                  onClick={() =>
                    this.handhandleShowHistorical(val.id_jenis_aturan)
                  }
                  className="btn btn-icon btn-success btn-sm"
                  style={{ minWidth: "50px", borderRadius: "12px" }}
                >
                  <i
                    class="flaticon2-time"
                    style={{ color: "#ffffff", fontSize: "14px" }}
                  ></i>
                </Button>
              </td>
            </tr>
          </>
        );
      }
      if (this.state.peningkatan.length > 0) {
        view = <>{penganturan_peningkatan}</>;
      } else {
        view = (
          <tr>
            <td
              colSpan="7"
              style={{
                textAlign: "center",
                fontSize: "12px",
                verticalAlign: "middle",
                fontStyle: "italic",
              }}
            >
              Belum ada data
            </td>
          </tr>
        );
      }
    } else {
      view = (
        <tr>
          <td colSpan="7">
            <LinearProgress color="secondary" variant="query" />
          </td>
        </tr>
      );
    }
    return (
      <>
        <NoticePeningkatan
          svg="/media/svg/icons/Home/Building.svg"
          style={{ marginBottom: "0px", boxShadow: "none" }}
        >
          <div className="d-flex align-items-center justify-content-between w-100">
            <div>
              <strong style={{ fontSize: "18px" }}>PENINGKATAN</strong>
              <p className="mb-0">Peningkatan standar dalam SPMI Institusi</p>
            </div>
            <div>
              <YearSelect />
            </div>
          </div>
        </NoticePeningkatan>
        <br />
        <Card style={{ padding: "2%" }}>
          {sessiondata.i_idrole === 3 ? (
            <div className="row" style={{ marginBottom: "20px" }}>
              <div className="col-md-12">
                <div style={{ float: "right" }}>
                  <ButtonToolbar>
                    <span className="svg-icon svg-icon-2x svg-icon-white">
                      <Button variant="primary" onClick={this.handleAdd}>
                        <i
                          class="flaticon-add"
                          style={{ color: "#ffffff", fontSize: "14px" }}
                        ></i>
                        &nbsp; Tambahkan Peningkatan Baru
                      </Button>
                    </span>
                  </ButtonToolbar>
                </div>
              </div>
            </div>
          ) : (
            ""
          )}
          <Table responsive style={{ overflow: "auto" }}>
            <thead
              className="text-white"
              style={{ backgroundColor: "#3047ad" }}
            >
              <tr>
                <th
                  style={{
                    fontSize: "12px",
                    textTransform: "uppercase",
                    verticalAlign: "middle",
                  }}
                >
                  Deskripsi
                </th>
                <th
                  style={{
                    textAlign: "center",
                    fontSize: "12px",
                    textTransform: "uppercase",
                    verticalAlign: "middle",
                  }}
                >
                  <ButtonToolbar>
                    Tautan
                    {["bottom"].map((placement) => (
                      <OverlayTrigger
                        key={placement}
                        placement={placement}
                        overlay={
                          <Tooltip id={`tooltip-${placement}`}>
                            <div style={{ textAlign: "left" }}>
                              Tautan yang telah ditetapkan untuk peningkatan
                              standar Perguruan Tinggi
                            </div>
                          </Tooltip>
                        }
                      >
                        <div>
                          &nbsp;&nbsp;
                          <span
                            style={{ fontSize: "15px" }}
                            className="text-white fa fa-info-circle"
                          ></span>
                        </div>
                      </OverlayTrigger>
                    ))}
                  </ButtonToolbar>
                </th>
                <th
                  style={{
                    textAlign: "center",
                    fontSize: "12px",
                    textTransform: "uppercase",
                    verticalAlign: "middle",
                  }}
                >
                  Tanggal Penetapan Baru
                </th>
                <th
                  style={{
                    textAlign: "center",
                    fontSize: "12px",
                    textTransform: "uppercase",
                    verticalAlign: "middle",
                  }}
                >
                  Status Verfikasi
                </th>
                <th
                  style={{
                    textAlign: "center",
                    fontSize: "12px",
                    textTransform: "uppercase",
                    verticalAlign: "middle",
                  }}
                >
                  Status Dokumen
                </th>
                <th
                  style={{
                    textAlign: "center",
                    fontSize: "12px",
                    textTransform: "uppercase",
                    verticalAlign: "middle",
                  }}
                >
                  Aksi
                </th>
              </tr>
            </thead>
            <tbody>{view}</tbody>
          </Table>
        </Card>
        <Modal size="lg" show={showDialogFormSave} onHide={this.handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Peningkatan standar dalam SPMI Institusi</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Label htmlFor="input-with-icon-adornment">
                Nama Standar
              </Form.Label>
              <Form.Row>
                <Select
                  multiple
                  value={jenis_peningkatan}
                  onChange={this.handleChangeMultiple}
                  input={<Input id="select-multiple-checkbox" />}
                  renderValue={(selected) => selected.join(", ")}
                  MenuProps={MenuProps}
                  style={{ minWidth: "760px" }}
                  placeholder="Pilih nama standar"
                >
                  {data_jenis_peningkatan.map((list, i) => (
                    <MenuItem key={list.nama_jenis} value={list.nama_jenis}>
                      <Checkbox
                        checked={
                          jenis_peningkatan.indexOf(list.nama_jenis) > -1
                        }
                      />
                      <ListItemText primary={list.nama_jenis} />
                    </MenuItem>
                  ))}
                </Select>
              </Form.Row>
              <br />
              <Form.Label htmlFor="input-with-icon-adornment">
                Deskripsi <small>*jika ada</small>{" "}
              </Form.Label>
              <Form.Control
                size="lg"
                type="text"
                as="textarea"
                placeholder="Deskripsi"
                value={deskripsi !== "null" ? deskripsi : "-"}
                onChange={(e) => this.onInputChangePengaturan(e, "deskripsi")}
              />
              <br />
              <Form.Label htmlFor="input-with-icon-adornment">
                Tanggal Penetapan{" "}
              </Form.Label>
              <Form.Control
                size="lg"
                type="date"
                value={tanggal_penetapan}
                onChange={(e) =>
                  this.onInputChangePengaturan(e, "tanggal_penetapan")
                }
              />
              <br />
              <Form.Label htmlFor="input-with-icon-adornment">
                Tautan laporan kegiatan peningkatan/catatan perubahan
                standar/draft standar hasil peningkatan{" "}
              </Form.Label>
              <Form.Control
                size="lg"
                type="text"
                placeholder="http:// ..."
                value={tautan}
                onChange={(e) => this.onInputChangePengaturan(e, "tautan")}
              />
              <div
                style={{
                  textAlign: "center",
                  padding: "10px",
                  marginTop: "15px",
                  marginRight: "20px",
                  marginLeft: "20px",
                }}
              >
                <Alert variant="warning">
                  <b>
                    *Catatan: Pastikan link/tautan yang diberikan dapat
                    diakses/dibaca oleh publik!
                  </b>
                  <br />
                  (General Access : Anyone With The Link)
                </Alert>
              </div>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <div style={{ textAlign: "right" }}>
              <Button
                disabled={loading}
                onClick={this.handleSavePeningkatan}
                style={{
                  marginRight: "1vw",
                  backgroundColor: "#2061e3",
                  color: "white",
                }}
                variant="primary"
              >
                SIMPAN
                {loading && <i className="ml-3 spinner spinner-white"></i>}
                &nbsp;&nbsp;
              </Button>
            </div>
            <Button variant="secondary" onClick={this.handleClose}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          size="lg"
          show={this.state.showHistorical}
          onHide={this.handleClose}
        >
          <Modal.Header closeButton>
            <Modal.Title>Riwayat Pengaturan Peningkatan</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Table responsive style={{ overflow: "auto" }}>
              <thead
                className="text-white"
                style={{ backgroundColor: "#3047ad" }}
              >
                <tr>
                  <th
                    style={{
                      textAlign: "center",
                      fontSize: "12px",
                      textTransform: "uppercase",
                      verticalAlign: "middle",
                    }}
                  >
                    Nama Standar
                  </th>
                  <th
                    style={{
                      textAlign: "center",
                      fontSize: "12px",
                      textTransform: "uppercase",
                      verticalAlign: "middle",
                    }}
                  >
                    Tautan Peningkatan
                  </th>
                  <th
                    style={{
                      textAlign: "center",
                      fontSize: "12px",
                      textTransform: "uppercase",
                      verticalAlign: "middle",
                    }}
                  >
                    Tanggal ditetapkan
                  </th>
                  <th
                    style={{
                      textAlign: "center",
                      fontSize: "12px",
                      textTransform: "uppercase",
                      verticalAlign: "middle",
                    }}
                  >
                    Status Verfikasi
                  </th>
                  <th
                    style={{
                      textAlign: "center",
                      fontSize: "12px",
                      textTransform: "uppercase",
                      verticalAlign: "middle",
                    }}
                  >
                    Status Dokumen
                  </th>
                </tr>
              </thead>
              <tbody>{view_historical}</tbody>
            </Table>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleClose}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}
export default PeningkatanPengelolaanStandar;
